import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=45f9a331&scoped=true&"
import script from "./ReviewForm.vue?vue&type=script&lang=js&"
export * from "./ReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9a331",
  null
  
)

export default component.exports